import React from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import styled from 'styled-components'

import LayoutsDispatch from './contextLayouts'

import CardClients from './cardClients'
import CardTickets from './cardTickets'
import CardRevenue from './cardRevenue'
import CardSubscribers from './cardSubscribers'
import Weather from './weather'
import Tasks from './cardTasks'
import TopCars from './cardTopCars'
import CardMonths from './cardMonths'


const ResponsiveGridLayout = WidthProvider(Responsive);

const Card = styled.div`
  cursor: grab;
  background-color: white;
  box-shadow: 0px 4px 4px rgba(0,0,0,0.25);
  border: 1px solid #E5E5E5;
`

const Wrapper = styled.div`
  width: 100%;
  padding: 0.6rem;
  padding-top: 0rem;
  position: relative;

`
const MemoW = React.memo(Weather)

const MemoR = React.memo(CardRevenue)
export default function MyResponsiveGrid ({gridState, tickets, tasks}) {
  const gridDispatch = React.useContext(LayoutsDispatch);

  function onDragStop(layout, oldItem, newItem, placeholder,e, element) {
    gridDispatch({type: 'setNewLayout', payload: {newX: oldItem.x, newY: oldItem.y, layout: layout}})
  }



  return (
    <Wrapper>
      <ResponsiveGridLayout  
        className="layout" 
        layouts={gridState}
        breakpoints={{lg: 980, md: 780, sm: 550, xs: 549, xxs: 0}}
        cols={{lg: 3, md: 3, sm: 2, xs: 1, xxs: 1}}
        onDragStop={onDragStop}
      >
        <Card key="a" color='blue'><Tasks tasks={tasks}></Tasks></Card>
        <Card key="b" color='purple'><CardTickets tickets={tickets}></CardTickets></Card>
        <Card key="c" color='magenta'><CardClients title='Top Clients' clients={['pippo', 'affio']} /></Card>
        <Card key="d" color='green'><MemoR></MemoR></Card>
        <Card key="e" color='yellow'><MemoW/></Card>
        <Card key="f" color='pink'><CardClients title='New Clients' clients={['pippo', 'affio']} /></Card>
        <Card key="g" color='orange'><CardMonths></CardMonths></Card>
        <Card key="h" color='grey'><CardSubscribers></CardSubscribers></Card>
        <Card key="i" color='red'><TopCars></TopCars></Card>
      </ResponsiveGridLayout >
    </Wrapper>
  )
}
